module.exports = __webpack_public_path__ + "static/media/add talent category.8195f647.svg";